<template>
  <div class="table">
    <el-table ref="myTable" :data="tableData.content" :default-sort="{ prop: '', order: 'descending' }"
      v-loading="tableData.loading" size="small" row-key="id" @row-click="clickRow" @sort-change="sorTable"
      @selection-change="checkButton">
      <el-table-column type="selection" width="45" v-if="tableData.isSelection" reserve-selection>
      </el-table-column>
      <el-table-column v-for="(item, index) in tableData.title" :key="index" show-overflow-tooltip :prop="item.prop"
        :label="item.label" :sortable=item.sortable :width="item.width" :fixed="item.fixed">
        <template slot-scope="scope">
          <span class="operation" v-if="item.prop == 'detail'">
            <span><a @click="skip('detail', scope.row)">查看</a></span>
          </span>
          <span class="operation" v-else-if="item.prop == 'client_order_detail'">
            <span><a @click="skip('detail', scope.row)">查看</a></span>
            <span v-if="scope.row.pay_type == 'partner' && scope.row.status == 0 && scope.row.is_partner == 'partner'">
              <span><a @click="skip('detail', scope.row)">代付</a></span>
              <span><a @click="skip('reject', scope.row)">驳回</a></span>
            </span>
          </span>
          <span v-else-if="item.prop == 'tagHover'">
            <el-popover placement="top" trigger="hover">
              <div class="tag_list">
                <ul>
                  <li v-for="(item, index) in scope.row.tag" :key="index">{{ item.tag_name }}</li>
                </ul>
                <a @click="skip('edit_tag', scope.row)">编辑标签</a>
              </div>
              <span class="iconfont iconfont2 icon-24gf-tag" slot="reference" style="cursor: pointer;"></span>
            </el-popover>
          </span>
          <span class="operation" v-if="item.prop == 'tagName'">
            <span><a @click="skip('toInstance', scope.row)">{{ scope.row.name }}</a></span>
          </span>
          <span class="operation" v-else-if="item.prop == 'detail_operation'">
            <span v-if="scope.row.ip == '-' && scope.row.eip_ip == '' ? false : true"><a
                @click="skip('security_group', scope.row)">安全组</a>|</span>
            <span><a @click="skip('detail', scope.row)">管理</a>|</span>
            <el-dropdown>
              <a class="more">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="scope.row.on" @click.native="skip('on', scope.row)">启动</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.off" @click.native="skip('off', scope.row)">关机</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.restart"
                  @click.native="skip('restart', scope.row)">重启</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.upgrade"
                  @click.native="skip('upgrade', scope.row)">升级</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.renew"
                  @click.native="skip('renew', scope.row)">续费</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.ip == '-'" :disabled="scope.row.eip_ip != ''"
                  @click.native="skip('bind', scope.row)">绑定弹性IP</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.ip == '-'" :disabled="scope.row.eip_ip == ''"
                  @click.native="skip('unbind', scope.row)">解绑弹性IP</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span class="operation" v-else-if="item.prop == 'rds_detail_operation'">
            <span><a @click="skip('detail', scope.row)">管理</a>|</span>
            <el-dropdown>
              <a class="more">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="scope.row.on" @click.native="skip('on', scope.row)">启动</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.off" @click.native="skip('off', scope.row)">关机</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.restart"
                  @click.native="skip('restart', scope.row)">重启</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.upgrade"
                  @click.native="skip('upgrade', scope.row)">升级</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.renew"
                  @click.native="skip('renew', scope.row)">续费</el-dropdown-item>
                <!-- <el-dropdown-item :disabled="scope.row.updown" @click.native="skip('updown',scope.row)">续费降配</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span class="operation" v-else-if="item.prop == 'slb_detail_operation'">
            <span><a @click="skip('detail', scope.row)">管理</a>|</span>
            <el-dropdown>
              <a class="more">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="scope.row.on" @click.native="skip('on', scope.row)">启动</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.off" @click.native="skip('off', scope.row)">关机</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.restart"
                  @click.native="skip('restart', scope.row)">重启</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.upgrade"
                  @click.native="skip('upgrade', scope.row)">升级</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.renew"
                  @click.native="skip('renew', scope.row)">续费</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.renew"
                  @click.native="skip('monitor', scope.row)">配置监听器</el-dropdown-item>
                <el-dropdown-item @click.native="skip('security_group', scope.row)">安全组</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>


          <span class="operation" v-if="item.prop == 'detail_operation2'">
            <span><a @click="skip('detail', scope.row)">查看</a></span>
            <span v-if="scope.row.status != '申请完成'">
              |
              <a @click="skip('delOrder', scope.row)">删除</a>
            </span>
            <span v-if="scope.row.status == '申请中'">
              |
              <a @click="skip('editOrder', scope.row)">修改</a>
            </span>
          </span>
          <span class="operation" v-if="item.prop == 'account_oper'">
            <span v-if="scope.row.run_status == 1">
              <span>
                <a @click="skip('resetPsd', scope.row)">重置密码</a></span>
              <span>
                |
                <a @click="skip('resetAccess', scope.row)">修改账号权限</a>
              </span>
              <span>
                |
                <a @click="skip('delete', scope.row)">删除</a>
              </span>
            </span>
            <span v-else style="color: #ccc;">
              <span>重置密码</span>
              <span>
                |
                修改账号权限
              </span>
              <span>
                |
                删除
              </span>
            </span>
          </span>
          <span class="operation" v-if="item.prop == 'sql_oper'">
            <!-- <span><a @click="skip('querySQL',scope.row)">SQL查询</a></span> -->
            <span v-if="scope.row.run_status == 1">
              <span>
                <a @click="skip('delete', scope.row)">删除</a>
              </span>
            </span>
            <span v-else style="color: #ccc;">
              <span>
                删除
              </span>
            </span>
          </span>
          <span class="operation" v-if="item.prop == 'white_oper'">
            <span v-if="scope.row.run_status == 1">
              <span><a @click="skip('edit', scope.row)">修改</a></span>
              <span>
                |
                <a @click="skip('delete', scope.row)">删除</a>
              </span>
            </span>
            <span v-else style="color: #ccc;">
              <span>修改</span>
              <span>
                |
                删除
              </span>
            </span>
          </span>
          <span class="operation" v-if="item.prop == 'backup_oper'">
            <!-- <span><a @click="skip('download',scope.row)">实例备份下载</a></span> -->
            <span v-if="scope.row.run_status == 1">
              <span>
                <a @click="skip('backup', scope.row)">恢复</a>
              </span>
              <span>
                |
                <a @click="skip('delete', scope.row)">删除</a>
              </span>
            </span>
            <span v-else style="color: #ccc;">
              <span>
                恢复
              </span>
              <span>
                |
                删除
              </span>
            </span>
          </span>
          <span class="operation" v-if="item.prop == 'recover_oper'">
            <span v-if="scope.row.run_status == 2" style="color: #ccc;">
              <span>
                删除
              </span>
            </span>
            <span v-else>
              <span>
                <a @click="skip('recover_delete', scope.row)">删除</a>
              </span>
            </span>
          </span>
          <span class="operation" v-else-if="item.prop == 'status_name_status'">
            <span> <span :class="['yuan', activeColor(scope.row.status, tableData.colorOptions)]"></span> {{
              scope.row.status_name }} </span>
          </span>
          <span class="operation" v-else-if="item.prop == 'refund_order'">
            <a class="text-primary" v-for="(item, index) in (scope.row[item.prop])" :key="index"
              @click="skip('refund_order', item)">{{ item }}</a></span>
          <span class="operation" v-else-if="item.prop == 'refund_apply'"
            @click="skip('refund_apply', scope.row)"><a>申请退款</a></span>
          <span class="operation" v-else-if="item.prop == 'recycle_renew'"
            @click="skip('recycle_renew', scope.row)"><a>续费</a></span>
          <span class="operation" v-else-if="item.prop == 'read'" @click="skip('message', scope.row)"><a>查看</a></span>
          <span class="operation" v-else-if="item.prop == 'renew'" @click="skip('contract', scope.row)"><a>续费</a></span>
          <span class="operation" v-else-if="item.prop == 'contract'"
            @click="skip('contract', scope.row)"><a>合同申请</a></span>
          <span class="operation" v-else-if="item.prop == 'invoice'"
            @click="skip('invoice', scope.row)"><a>开具发票</a></span>
          <span class="operation" v-else-if="item.prop == 'amount_text'">
            <span>{{ scope.row.amount }}</span><br />
            <span v-if="scope.row.over_amount == '0.00'" style="color: #ff6600;">无门槛</span>
            <span v-else style="color: #ff6600;">满{{ scope.row.over_amount }}元可用</span>
          </span>
          <span class="operation" v-else-if="item.prop == 'coupon'" @click="skip('useRecord', scope.row)"><a
              v-if="scope.row.order_id != null">使用记录</a></span>
          <span class="operation" v-else-if="item.prop == 'snapshot_operation'">
            <span v-if="scope.row.status != '失效'">
              <a @click="skip('restore', scope.row)">
                {{ scope.row.status === '失效' ? '失效' : '回滚' }}
              </a>
              |
            </span>
            <span v-else><a style="color:#bbb;">{{ scope.row.status === '失效' ? '失效' : '回滚' }}</a>
              |
            </span>

            <a @click="skip('delete', scope.row)">删除</a>
          </span>
          <span class="operation" v-else-if="item.prop == 'slb_black_ip_operation'">
            <a @click="skip('delete', scope.row)">删除</a>
          </span>
          <span class="operation" v-else-if="item.prop == 'operation'">
            <a @click="skip('edit', scope.row)">修改</a>|
            <a @click="skip('delete', scope.row)">删除</a>
          </span>

          <span class="operation" v-else-if="item.prop == 'audit'">
            <a @click="skip('audit', scope.row)">审核</a>
          </span>
          <span class="operation" v-else-if="item.prop == 'unbind'">
            <a @click="skip('unbind', scope.row)">同意解绑</a>|
            <a @click="skip('reject', scope.row)">驳回</a>
          </span>
          <span class="operation" v-else-if="item.prop == 'download'">
            <a @click="skip('download', scope.row)">下载</a>
          </span>
          <span class="operation" v-else-if="item.prop == 'enter' && scope.row.status === -1">
            <a @click="skip('enter', scope.row)">确认</a>
          </span>
          <span class="operation" v-else-if="item.prop == 'three'">
            <!-- <a @click="skip('edit',scope.row)" disabled>编辑</a>
            <a @click="skip('outage',scope.row)"> {{ scope.row.status === 1 ? '停用' : '启用' }} </a>
            <a @click="skip('delete',scope.row)">删除</a> -->
            <el-button type="text" @click="skip('edit', scope.row)" :disabled="scope.row.status === 0">编辑</el-button>
            <el-button type="text" @click="skip('outage', scope.row)" :disabled="scope.row.status === 0">{{
              scope.row.status === 1 ? '停用' : '启用' }}</el-button>
            <el-button type="text" @click="skip('delete', scope.row)" :disabled="scope.row.status === 0">删除</el-button>
          </span>

          <span v-else-if="item.prop == 'flavor'">
            规格：{{ scope.row.cpu }}核{{ scope.row.ram }}G<br />
            带宽：{{ scope.row.eip_bandwidth != '' && scope.row.eip_bandwidth !=
              undefined ? scope.row.eip_bandwidth : scope.row.bandwidth }}M
          </span>
          <span v-else-if="item.prop == 'rds_flavor'">
            规格：{{ scope.row.cpu }}核{{ scope.row.ram }}G<br />
          </span>
          <span v-else-if="item.prop == 'slb_flavor'">
            名称：{{ scope.row.flavor_name }}<br />
            带宽：{{ scope.row.bandwidth }}M<br />
          </span>
          <span v-else-if="item.prop == 'pay_amount' || item.prop == 'days'" class="text-stress">
            {{ scope.row[item.prop] }}
          </span>
          <!-- <span v-else-if="item.prop == 'ip'" class="">
           {{scope.row[item.prop]}}
           <div>(<span class="text-stress">{{scope.row.local_ip}}</span>)</div>
          </span> -->

          <span v-else-if="item.prop == 'ip'">
            <div v-if="scope.row.eip_ip == '' || scope.row.eip_ip == undefined">
              <span>公网:{{ scope.row[item.prop] ? scope.row[item.prop] : '--' }}</span>
            </div>
            <div v-else style="display: flex;align-items: center;"><span>公网:{{ scope.row.eip_ip }}</span><img
                src="../assets/img/eip.png" alt="" style="margin-left: 5px;margin-top: -4px;" width="18px"
                height="18px"></div>
            <div><span>内网:{{ scope.row.local_ip ? scope.row.local_ip : '--' }}</span></div>
          </span>

          <span v-else-if="item.prop == 'bind_server'">
            <div v-if="scope.row.bind_server.name == ''">--</div>
            <div v-else><span>{{ scope.row.bind_server.name }}</span><span class="margin-left-10">{{
              scope.row.bind_server.local_ip }}</span></div>
          </span>
          <span v-else-if="item.prop == 'system'">
            <span v-if="scope.row.system_name.toLowerCase().includes('win')">
              <i class="iconfont2 icon-windows"></i>
            </span>
            <span v-else>
              <i v-if="scope.row.system_name.toLowerCase().includes('centos')" class="iconfont2 icon-centos"></i>
              <i v-if="scope.row.system_name.toLowerCase().includes('ubuntu')" class="iconfont2 icon-icon_ubuntu"></i>
              <i v-if="scope.row.system_name.toLowerCase().includes('debian')" class="iconfont2 icon-debian"></i>
              <img
                v-if="scope.row.system_name.toLowerCase().includes('rocky')"
                src="https://rockylinux.org/favicon.png"
                alt=""
                class="system-os-icon"
              />
            </span>
            <span>{{ scope.row.system_name }}</span>
          </span>
          <span v-else-if="item.prop == 'status'" class="icon-location">
            <i v-if="scope.row.statusIcon"
              :class="[{ 'icon-status': scope.row.statusIcon != 'el-icon-loading' }, scope.row.statusIcon]"></i>
            <span>{{ scope.row[item.prop] }}</span>
          </span>
          <span v-else-if="item.prop == 'read_status'" class="icon-location">
            <i v-if="scope.row.statusIcon"
              :class="[{ 'icon-status': scope.row.statusIcon != 'el-icon-loading' }, scope.row.statusIcon]"></i>
            <span>{{ scope.row[item.prop] }}</span>
          </span>
          <span v-else-if="item.prop == 'edit_name'">
            <div v-if="!scope.row.nameEdit"
              style="width: 150px;display: inline-block;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;vertical-align: middle;">
              {{ scope.row.name }}</div>
            <el-input v-model="scope.row.name" v-else size="medium" style="width: 150px;"
              @change="skip('name_change', scope.row)"></el-input>
            <i class="el-icon-edit" style="margin-left: 5px;cursor: pointer;" @click="skip('edit_name', scope.row)"></i>
          </span>
          <span v-else-if="item.prop == 'edit_value'" style="display: flex;align-items: center;">
            <div v-if="!scope.row.valueEdit"
              style="width: 200px;display: inline-block;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;vertical-align: middle;">
              {{ scope.row.run_value_f }}</div>
            <el-input v-model="scope.row.run_value_f" v-else size="medium" style="width: 200px;"></el-input>
            <i v-if="!scope.row.valueEdit" class="el-icon-edit"
              :class="scope.row.run_value_f != scope.row.run_value ? 'icon_red' : ''"
              style="margin-left: 5px;cursor: pointer;" @click="skip('edit_value', scope.row)"></i>
            <div v-else class="update_btns"><span class="sub" @click="skip('value_change', scope.row)">确定</span><span
                @click="skip('value_cancel', scope.row)">取消</span></div>
          </span>
          <span v-else-if="item.prop == 'renew_auto'">
            <el-switch v-model="scope.row.renew_auto" active-color="#4E77FF" inactive-color="#ddd"
              @change="skip('renew_change', scope.row)">
            </el-switch>
          </span>
          <span class="operation" v-else-if="item.prop == 'eip_operation'">
            <span v-if="scope.row.statusNum == 2">
              <a @click="skip('renew', scope.row)">续费</a>
            </span>
            <span v-else>
              <span>
                <a @click="skip('bind', scope.row)" v-if="scope.row.statusNum == -1">绑定</a>
                <span v-else style="color: #7F7F7F;">绑定</span>
              </span>
              <span>
                |
                <a @click="skip('unbind', scope.row)" v-if="scope.row.statusNum == 1">解绑</a>
                <span v-else style="color: #7F7F7F;">解绑</span>
              </span>
              <span>
                |
                <a @click="skip('renew', scope.row)">续费</a>
              </span>
              <span>
                |
                <a @click="skip('upgrade', scope.row)">升级</a>
              </span>
            </span>
          </span>
          <span v-else-if="item.prop == 'refound_order_id'">
            <span v-if="scope.row.is_refund == 1" style="text-decoration: line-through">{{scope.row.order_id}}</span>
            <span v-else>{{scope.row.order_id}}</span>
          </span>
          <span class="operation" v-else-if="item.prop == 'edit_sk'">
            <a @click="skip('editSk', scope.row)">修改</a>
          </span>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination class="page-number" v-if="tableData.page.enabled" background
        layout="jumper, prev, pager, next,sizes, total" :current-page.sync="tableData.page.curr"
        @size-change="sizeChange" @current-change="pageChange" :page-sizes="[tableData.page.size, 30, 50, 100]"
        :page-size="tableData.page.size" :total="tableData.page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "my-table",
  props: ['tableData'],
  data() {
    return {
      defaultOptions: {
        '1': 'green',
        '-1': 'red',
        '0': 'delete',
      }
    }
  },
  methods: {
    checkButton(val) {
      this.$emit('sendCheckButton', val)
    },
    openDetail(val) {
      this.$emit('sendOpenDetail', val)
    },
    sorTable(val) {
      if (val.prop != '') {
        this.$emit('sendSorTable', val)
      }
    },
    clickRow(val) {
      this.$refs.myTable.toggleRowSelection(val);
    },
    clearCheckRow() {
      this.$refs.myTable.clearSelection()
    },
    sizeChange(val) {
      this.$emit('sendSizeChange', val)
    },
    pageChange(val) {
      let that = this;
      clearTimeout(that.timer);
      that.timer = setTimeout(function () {
        that.$emit('sendPageChange', val);
      }, 250);
    },
    skip(type, val) {
      this.$emit('sendSkip', type, val)
    },
    imageClick(val, type) {
      this.$emit('sendImageClick', val, type);
    },

    activeColor(status, options = this.defaultOptions) {
      let str = ''
      Object.keys(options).forEach(key => {
        if (Number(key) === Number(status)) {
          str = options[key]
        }
      })
      return str
    },
  },

}
</script>

<style scoped lang="scss">
.table {
  margin: 24px 0;
}

.page-number {
  float: right;
  margin-top: 20px;
}

.operation {
  a {
    color: #4E77FF;
    cursor: pointer;
    padding: 0 3px;
  }

  a:active {
    color: #B44354;
  }
}

.more {
  font-size: 12px;
}

.icon-location {
  display: flex;
  align-items: center;

  span {
    line-height: 22px;
  }
}

.el-button+.el-button {
  margin-left: 3px;
}

.el-button {
  font-size: 12px;
}

.yuan {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.red {
  background: red;
}

.green {
  background: #61cd61;
}

.warning {
  background: #E6A23C;
}

.delete {
  background: #ccc;
}

.black {
  background: #000;
}

.keyButton.el-button {
  width: 100%;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 0 !important;
  background: transparent;
  padding: 0 !important;
}

.keyButton.el-button:hover {
  border: 0 !important;
  background: transparent;
  padding: 0 !important;
}

.tag_list {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tag_list ul {
  display: flex;
  align-items: center;
}

.tag_list ul li {
  padding: 0 12px;
  height: 24px;
  line-height: 24px;
  border-radius: 12px;
  border: 1px solid #C0C6CC;
  margin: 0 2px;
  font-size: 12px;
  color: #333;
}

.tag_list a {
  color: #4E77FF;
  font-size: 12px;
  margin: 0 10px;
  cursor: pointer;
}

.iconfont:before {
  color: #000 !important
}

.update_btns {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 12px;
  color: #999;
}

.update_btns .sub {
  color: #4E78FD
}

.update_btns span {
  cursor: pointer;
  margin-left: 10px;
}

.icon_red {
  color: red !important;
}

.system-os-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 2px;
  filter: grayscale(100%) brightness(0);
  opacity: 0.58;
}
</style>



// WEBPACK FOOTER //
// src/components/myTable.vue